'use client';

import type { ReactNode } from 'react';
import { AppProviders } from '@mic-miconnect/lib-ui';
import { UserProvider } from '@shared/contexts/UserContext';
import { ReactQueryProvider } from './ReactQueryProvider';

interface Props {
  children: ReactNode;
}

export function Providers({ children }: Props) {
  return (
    <AppProviders>
      <UserProvider>
        <ReactQueryProvider>{children}</ReactQueryProvider>
      </UserProvider>
    </AppProviders>
  );
}
